module.exports = __webpack_public_path__ + "img/emoji_44.1ad1f9ec.png";